import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Subscriber, Observable } from '../../../../node_modules/rxjs';
import { GetLanguagesService } from '../services/get-languages.service';
import { RootScopeDeclare } from '../rootscope-declare';
import { RootScopeService } from '../shared-service/root-scope.service';
import { TranslateService } from '@ngx-translate/core';
import { AmplitudeAnalyticsService } from '../services/amplitude-analytics.service';


@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.css']
})
export class LanguageDropdownComponent implements OnInit {
  selectedLanguage: any[];
  languageOpted: string;
  rootScopeData: RootScopeDeclare;
  languageDropdownVisibility: boolean = false;
  @Input() fromPage: string;
  @Input() langCode: string;
  @Output() widgetLanguage = new EventEmitter();

  constructor(private _getLanguages: GetLanguagesService, private rootScopeService: RootScopeService, public translate: TranslateService,    
    private _amplitudeAnalytics: AmplitudeAnalyticsService) { }

  ngOnInit() {
    this.getRootScopeData();

    this._getLanguages.getLanguages()
      .then(
        data => {
          this.selectedLanguage = data;
          let storageLang = this.selectedLanguage.filter(x => x.langCode === 'en_US')[0];
          if (localStorage.getItem('selectedLang')) {
            storageLang = this.selectedLanguage.filter(x => x.langCode === localStorage.getItem('selectedLang'))[0];
          }
          if (this.fromPage === "widget" && this.langCode != undefined) {
            storageLang = this.selectedLanguage.filter(x => x.langCode === this.langCode)[0];
          }
          this.selectLanguage(storageLang, false);
        }
      );

  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }


  selectLanguage(language: { name: string; langCode: string; }, isUserChanged: boolean) {    
    if(isUserChanged) this._amplitudeAnalytics.logEvent({ 
      elementName: 'Language', 
      action: 'Language Change',
      additionalProperty: {
        from: this.rootScopeData.selectedLang,
        to: language.langCode
      }
    });

    this.languageDropdownVisibility = false;
    this.rootScopeData.translationsLoaded = false;
    this.languageOpted = language.name;
    this.widgetLanguage.emit(language.langCode);
    if (this.fromPage != "widget") {
      this.rootScopeData.selectedLang = language.langCode;
      localStorage.setItem('selectedLang', language.langCode);
      this.translate.use(this.rootScopeData.selectedLang)
        .subscribe((res: any) => {
          this.rootScopeData.translationsLoaded = true;
        });
      if (this.rootScopeData.selectedLang === 'ar' || this.rootScopeData.selectedLang === 'he') {
        this.rootScopeService.changeToRtl();
      } else {
        this.rootScopeService.changeToLtr();
      }
    } else if (this.fromPage === "widget" && isUserChanged) {
      this.rootScopeData.isPageHasUnsavedChanges = true;
    }
  }
}
